const tabsRootContextKey = Symbol("tabsRootContextKey");

export { tabsRootContextKey };
//# sourceMappingURL=tabs.mjs.map
